import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import approveImpactAnalysisDialog from './dialog.approveImpactAnalysisDialog';
import performBusinessImpactAnalysisDialog from './dialog.performBusinessImpactAnalysisDialog';
import prioritizeImpactAnalysisDialog from './dialog.prioritizeImpactAnalysisDialog';
import bulkSubmitImpactAnalysisDialog from './dialog.bulkSubmitImpactAnalysisDialog';
import bulkApproveImpactAnalysisDialog from './dialog.bulkApproveImpactAnalysisDialog';
import resetImpactAnalysisDialog from './dialog.resetImpactAnalysisDialog';
import controller from './impact-analysis.controller';
import directive from './impact-analysis.directive';
import impactAnalysisProcess from './impactAnalysisProcess';


export default angular.module('app.components.advisory.bcp.impactAnalysis', [
  approveImpactAnalysisDialog,
  bcpDataService,
  constants,
  impactAnalysisProcess,
  loaderService,
  performBusinessImpactAnalysisDialog,
  prioritizeImpactAnalysisDialog,
  bulkSubmitImpactAnalysisDialog,
  bulkApproveImpactAnalysisDialog,
  resetImpactAnalysisDialog,
  ssDialogService,
])
  .directive('bcpImpactAnalysis', directive)
  .controller('ImpactAnalysisController', controller)
  .name;

console.log('app.components.advisory.bcp.impactAnalysis created');
